<template>
  <div class="aptitudeTest-container">
    <!-- <v-header title="性向测试结果"></v-header> -->
    <el-container class="container">
      <el-header class="search-form">
        <div class="search-header">查询条件</div>
        <div>
          <label class="title">机构：</label>
          <el-cascader
            v-model="queryParams.organCodes"
            :options="manageComNameOptions"
            :props="cascaderProps"
            :show-all-levels="false"
            clearable
            size="mini"
            placeholder="请选择机构"
          >
          </el-cascader>
        </div>
        <div>
          <label class="title">候选人姓名：</label>
          <el-input
            size="mini"
            v-model="queryParams.accountName"
            @input="
              queryParams.accountName = queryParams.accountName.replace(
                /[^a-zA-Z\u4E00-\u9FA5]/g,
                ''
              )
            "
            maxlength="30"
            clearable
            placeholder="请输入姓名"
          ></el-input>
        </div>
        <div>
          <label class="title">性向测试完成时间：</label>
          <el-date-picker
            size="mini"
            v-model="queryParams.dateRange"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="to"
            start-placeholder="开始"
            end-placeholder="截至"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </div>
        <div>
          <label class="title">候选人联系电话：</label>
          <el-input
            size="mini"
            v-model="queryParams.accountPhone"
            maxlength="11"
            clearable
            placeholder="请输入电话"
          ></el-input>
        </div>
        <div>
          <label class="title">候选人证件类型：</label>
          <el-select
            size="mini"
            v-model="queryParams.accountCertType"
            clearable
            placeholder="请选择证件类型"
          >
            <el-option
              v-for="item in idTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <label class="title">候选人证件号码：</label>
          <el-input
            size="mini"
            v-model="queryParams.accountCertCode"
            @input="
              queryParams.accountCertCode = queryParams.accountCertCode.replace(
                /[^a-zA-Z0-9]/g,
                ''
              )
            "
            maxlength="25"
            clearable
            placeholder="请输入证件号码"
          ></el-input>
        </div>
        <div style="float: right">
          <el-button type="primary" size="mini" @click="searchFunc"
            >查询</el-button
          >
          <el-button type="primary" size="mini" @click="exportExcelFunc"
            >导出</el-button
          >
          <el-button type="info" size="mini" @click="resetFunc"
            >重置</el-button
          >
        </div>
      </el-header>

      <el-main class="table-container">
        <el-table
          :cell-style="tableCellStyle"
          :header-cell-style="tableHeaderColor"
          v-loading="loading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          :data="tableData"
          border
          stripe
          style="width: 100%"
          height="100%"
        >
          <el-table-column
            fixed
            align="center"
            type="index"
            label="序号"
            width="50"
          >
          </el-table-column>
          <el-table-column
            fixed
            align="center"
            prop="branch"
            show-overflow-tooltip
            label="分公司"
          >
          </el-table-column>
          <el-table-column
            fixed
            align="center"
            prop="organ"
            show-overflow-tooltip
            label="机构"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="accountName"
            show-overflow-tooltip
            label="姓名"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="certType"
            width="200"
            show-overflow-tooltip
            label="证件类型"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="certCode"
            width="200"
            show-overflow-tooltip
            label="证件号码"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="mobile"
            width="150"
            show-overflow-tooltip
            label="手机号码"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="lifeNode"
            width="150"
            show-overflow-tooltip
            label="当前招募状态"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="testTime"
            width="180"
            show-overflow-tooltip
            label="性向测试完成时间"
          >
          </el-table-column>
          <el-table-column
            align="center"
            width="180"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="viewDetailsFunc(scope.row.serverFileId)"
                >查看</el-button
              >
              <el-button type="text" @click="exportFunc(scope.row.serverFileId)"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>

      <el-footer>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.pageNum"
          :page-size="20"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-footer>
    </el-container>
    <!-- <div class="container" v-if="!show">
      
      <el-button type="primary" class="backBtn" @click="backFunc">返回</el-button>
    </div> -->
  </div>
</template>

<script>
import url from "@/modules/url";
import api from "@/modules/api";
import tableBaseCss from "../tableBaseCss";
import { Options } from "@/components/utils/fixOptions";
// import vHeader from "@/layout/Header1.vue";
export default {
  name: "aptitudeTest",
  // components: { vHeader },
  mixins: [tableBaseCss],

  data() {
    return {
      show: true, // 区分显示表示数据模块还是显示数据详情模块的变量
      token: "", // 设置存储token的变量
      idTypeOptions: Options.id_type,
      // 定义查询条件的参数对象
      queryParams: {
        organCodes: [], // 机构编码
        accountName: "", // 姓名
        testTimeStart: "", // 性向测试完成起始时间
        testTimeEnd: "", // /性向测试完成截止时间
        dateRange: [], //性向测试完成时间
        accountPhone: "", // 候选人联系电话
        accountCertType: "", // 候选人证件类型
        accountCertCode: "", // 候选人证件号码
        lifeNode: null, // 当前招募状态
        pageNum: 1, // 每页展示的数据条数
        pageSize: 20, // 页码数，初始化默认为'1'
      },
      tableData: [], // 定义存储表格数据的集合
      total: 0, // 数据总条数
      loading: false, // 定义是否开启表格的加载遮罩的变量
      manageComNameOptions: [], // 存储机构下拉菜单数据的集合
      cascaderProps: {
        multiple: true,
        value: "code", // 指定 value 字段
        label: "name", // 指定 label 字段
        children: "childList", // 指定 children 字段
      },
      pickerOptions() {
        const [start, end] = this.queryParams.dateRange || [];
        return {
          disabledDate: (time) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // 如果你想禁用今天之前的时间，也可以在这里控制

            if (start && !end) {
              // 已选开始日期，限制结束日期 >= 开始日期
              return time.getTime() < new Date(start).getTime();
            } else if (!start && end) {
              // 已选结束日期，限制开始日期 <= 结束日期
              return time.getTime() > new Date(end).getTime();
            }
            // 示例：不允许选择今天之前的日期（如不需要，可删掉）
            // return time.getTime() < today.getTime();
            return false;
          },
        };
      },
    };
  },
  mounted() {
    console.log(this.$linkUrl, "$linkUrl ========================");
    // 开启表格加载遮罩层
    this.loading = true;
    // 调用获取coookie中得token数据的方法
    this.getCookieData();
    // 调用查询获取机构下拉菜单数据集合的方法
    this.getManageComNameSelectDataFunc();
    // 为了防止接口异步调用问题，给查询获取表格数据的方法添加一个1.5秒的等待时间
    setTimeout(() => {
      // 调用查询获取表格数据的方法
      this.queryDataFunc();
    }, 1500);
  },
  methods: {
    // 下载
    exportFunc(fileId) {
      let fileUrl = this.$downloadUrl + fileId + ".pdf";
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "性向测试结果.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // 查看详情
    viewDetailsFunc(fileId) {
      // this.show = false
      window.open(this.$linkUrl + fileId + ".pdf");
    },

    // 查看详情模块部分中点击‘返回’按钮执行的方法
    backFunc() {
      this.show = true;
    },

    // 查询
    searchFunc() {
      // 点击搜索时，要将页码数重置为1，因为查询的是从第一页开始的数据
      this.queryParams.pageNum = 1;
      // 调用查询获取表格数据的方法
      this.queryDataFunc();
    },

    // 导出
    exportExcelFunc() {
      if (this.tableData.length != 0) {
        let that = this;
        let {
          dateRange,
          organCodes,
          accountName,
          accountPhone,
          accountCertType,
          accountCertCode,
          pageNum,
          pageSize,
        } = that.queryParams;
        if (!dateRange) {
          dateRange = [];
        }
        let data = {
          organCodes: organCodes,
          accountName: accountName,
          testTimeStart: dateRange[0] || "",
          testTimeEnd: dateRange[1] || "",
          accountPhone: accountPhone,
          accountCertType: accountCertType,
          accountCertNo: accountCertCode,
        };
        if (dateRange[0]) {
          data.testTimeStart = dateRange[0] + " 00:00:00";
        }
        if (dateRange[1]) {
          data.testTimeEnd = dateRange[1] + " 23:59:59";
        }
        api.post(url.exportExamResult, data, (res) => {
          if (res.result.isSuccess) {
            const elink = document.createElement("a");
            elink.download = "性向测试结果列表.xlsx";
            console.log(this.$downloadUrl + res.data.fileId, "=====");
            elink.href = this.$downloadUrl + res.data.fileId;
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
          } else {
            this.$message({
              type: "error",
              message: res.error,
            });
          }
        });
      } else {
        return false;
      }
    },

    // 重置
    resetFunc() {
      (this.queryParams = {
        organCodes: [],
        accountName: "",
        testTimeStart: "",
        testTimeEnd: "",
        dateRange: [],
        accountPhone: "",
        accountCertType: "",
        accountCertCode: "",
        pageNum: 1,
        pageSize: 20,
      }),
        this.queryDataFunc();
    },

    //获取coookie中得token数据的方法
    getCookieData() {
      // 先重置清空变量，防止数据有缓存
      this.token = "";
      let arr,
        reg = new RegExp("(^| )" + "jtl" + "=([^;]*)(;|$)"),
        obj = document.cookie.match(reg);
      obj instanceof Array && (arr = obj);
      this.token = arr && unescape(arr[2]);
    },

    getManageComNameSelectDataFunc() {
      api.post(url.getOrgListService, {}, (res) => {
        if (res.result.isSuccess) {
          this.manageComNameOptions = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.error,
          });
        }
      });
    },

    // 查询获取表格数据的方法
    queryDataFunc() {
      let that = this;
      console.log(
        this.queryParams,
        "this.queryParams ========================"
      );
      let {
        dateRange,
        organCodes,
        accountName,
        accountPhone,
        accountCertType,
        accountCertCode,
        pageNum,
        pageSize,
      } = that.queryParams;
      if (!dateRange) {
        dateRange = [];
      }
      let data = {
        organCodes: organCodes,
        accountName: accountName,
        testTimeStart: dateRange[0] || "",
        testTimeEnd: dateRange[1] || "",
        accountPhone: accountPhone,
        accountCertType: accountCertType,
        accountCertNo: accountCertCode,
        pageNum: pageNum,
        pageSize: pageSize,
      };
      if (dateRange[0]) {
        data.testTimeStart = dateRange[0] + " 00:00:00";
      }
      if (dateRange[1]) {
        data.testTimeEnd = dateRange[1] + " 23:59:59";
      }
      api.post(url.queryAccountTestResultPage, data, (res) => {
        if (res.result.isSuccess) {
          // 将数据赋值给存储表格数据的集合
          this.tableData = res.data.rows;
          // 将数据总条数赋值给对应的变量
          this.total = ~~res.data.total;
        } else {
          this.$message({
            type: "error",
            message: res.result.error,
          });
        }
        // 关闭表格加载遮罩层
        this.loading = false;
      });
    },

    // 切换选择的机构数据的方法
    handleChange(value) {
      // 将选择的T2机构的机构代码，赋值给对应的变量
      this.queryParams.t2 = value[0];
      // 将选择的T3机构的机构代码，赋值给对应的变量
      this.queryParams.t3 = value[1];
    },

    // 切换当前页码
    handleCurrentChange(val) {
      // 切换页码后，将当前的页码数赋值给变量
      this.queryParams.pageNum = val;
      // 调用查询获取表格数据的方法
      this.queryDataFunc();
    },
  },
};
</script>

<style lang="scss" scoped>
.aptitudeTest-container {
  /deep/ .container {
    width: calc(100% - 30px);
    margin: 0 auto;
    margin-top: 15px;
    padding-bottom: 15px;
    background: #ffffff;
    height: calc(100vh - 110px);
    display: flex;
    flex-direction: column;
  }

  .el-header {
    height: auto !important;

    .el-row {
      margin-top: 20px;
    }

    .el-input {
      width: 210px;
    }
  }

  .table-container {
    margin-top: 10px;
    flex: 1;
    overflow: hidden;
    position: relative;
  }
  .el-main {
    flex: 1;
    padding: 0;
    overflow: hidden;
    
    /deep/ .el-table {
      height: 100%;
    }
    
    /deep/ .el-table__body-wrapper {
      overflow-y: auto;
      overflow-x: auto;
    }
    
    /deep/ thead {
      .el-table__cell {
        background: #f5f7fa;
      }
    }
  }

  .el-footer {
    text-align: right;
  }

  button {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit/aptitudeTest/list.vue